export default {
  /*按钮*/
  bt: {
    search: 'Tìm',
    find: 'Tìm kiếm',
    reset: 'Cài lại',
    add: 'Thêm vào',
    save: 'Lưu',
    saveAndNext: 'Lưu tới kế',
    noAndNext: '暂不评估，下一条',
    operator: 'Thao tác',
    update: 'Sửa đổi',
    delete: 'Xóa bỏ',
    down: 'Tải xuống',
    export: 'Tải về',
    upload: 'Tải lên',
    hideOrNo: 'Hiện/ẩn danh sách',
    definite: 'Xác nhận',
    cancel: 'Hủy bỏ',
    addOne: 'Thêm 1 cái',
    edit: 'Biên tập',
    allSelect: 'Chọn tất cả',
    downModel: 'Tải bản mẫu',
    uploadNow: 'Tải lên ngay',
    allOpen: 'Mở rộng tất cả',
    allClose: 'Thu tất cả'
  },
  /*公用字段或工具函数字段*/
  common: {
    companyId: 'Công ty id',
    bizCode: 'Ngành',
    bizCodeName: 'Thuộc Ngành',
    placeholderBizCodeName: 'Xin chọn ngành',
    locale: 'Ngôn ngữ',
    placeholderLanguage: 'Xin chọn ngôn ngữ',
    enable: 'trạng thái',
    startTime: 'TG bắt đầu',
    placeholderStartTime: 'Xin chọn TG bắt đầu',
    endTime: 'TG kết thúc',
    placeholderEndTime: 'Xin chọn TG kết thúc',
    createDate: 'Creation time',
    updateDate: 'TG Cập nhật ',
    replyTime: 'TG kết nối',
    enableNo: 'Cấm dụng',
    enableYes: 'Kích hoạt',
    no: 'Không',
    yes: 'Đúng',
    online: 'Trực tuyến',
    business: 'Bận',
    offline: 'Ngoại tuyến',
    tip: 'Lời khuyên',
    mobile: 'Bản di động',
    pc: 'Bản Máy tính',
    app: 'Bản APP',
    cancelDel: 'Đã hủy xóa',
    delForever: 'Thao tác này sẽ xóa vĩnh dữ liệu này, bạn có muốn tiếp tục?',
    delSuc: 'Xóa thành công!',
    delFail: 'Xóa thất bại, vui lòng thử lại sau',
    addSuc: 'Thêm thành công',
    addFail: 'Thêm thất bại, vui lòng thử lại sau',
    updateSuc: 'Cập nhật thành công',
    updateFail: 'Cập nhật thất bại, vui lòng thử lại sau',
    notExceed: 'Thêm không nhiều hơn 3 cái',
    notNull: 'Nội dung nhập vào không thể bỏ trống, xin nhập lại!',
    send: 'Gửi',
    name: 'Tên',
    placeholderName: 'Xin nhập tên',
    phone: 'Số điện thoại',
    email: 'Hộp thư',
    placeholderEmail: 'Xin nhập vào email',
    tel: 'ĐT cố định',
    telephone: 'Điện thoại',
    placeholderPhone: 'Xin nhập vào điện thoại',
    qq: 'QQ',
    placeholderQQ: 'Xin nhập vào số QQ',
    weChat: 'WeChat',
    placeholderWeChat: 'Xin nhập vào id wechat',
    zalo: 'Zalo',
    facebook: 'Facebook',
    whatsApp: 'Whatsapp',
    remark: 'Ghi chú',
    placeholderRemark: 'Xin nhập vào tên ghi chú',
    title: 'Tiêu đề',
    file: 'Files',
    fileTitle: 'Tiêu đề tệp',
    fileName: 'Tên file tin',
    uploadTime: 'Thời gian tải lên',
    hreAddress: 'Link',
    pic: 'Hình ảnh',
    picTitle: 'Tiên đề hình ảnh',
    visitorsType: 'Loại hình khách phỏng',
    placeholderVisitorsType: 'Xin chọn loại hình khách phỏng',
    businessType: 'Loại hình nghiệp vụ',
    placeholderBusinessType: 'Xin chọn loại hình nghiệp vụ',
    traveler: 'Du khách',
    demo: 'Demo',
    inactivated: 'Chưa kích hoạt',
    activated: 'Đã kích hoạt',
    accountNum: 'Tài khoản giao dịch',
    placeholderAccountNum: 'Xin nhập vào số TK giao dịch',
    visitorsName: 'Tên nick khách',
    placeholderVisitorsName: 'Vui lòng nhập tên khách',
    visitorsID: 'Id khách phỏng vấn',
    placeholderVisitorsID: 'Xin nhập vào ID khách phỏng',
    visitorsIp: 'IP khách phỏng',
    placeholderVisitorsIp: 'Vui lòng nhập IP của khách',
    visitorsAddress: 'Khu vực du khách',
    placeholderProvince: 'Vui lòng chọn tỉnh',
    placeholderCity: 'Vui lòng chọn thành phố',
    visitorsSource: 'Nguồn khách',
    visitorsNum: 'Lượt truy cập',
    massageTime: 'TG nhắn tin',
    status: 'trạng thái',
    placeholderStatus: 'Xin chọn trạng thái',
    replayTime: 'TG trả lời',
    massageType: 'Loại tin nhắn',
    replayOperator: 'Người trả lời',
    placeholderReplayOperator: 'Vui lòng nhập người trả lời',
    detail: 'Chi tiết',
    userTypeName: 'Loại hình khách hàng',
    visitorsWay: 'Phương thức phỏng vấn',
    sort: 'Xếp hạng',
    content: 'Nội dung',
    clientDetail: 'Trình duyệt',
    address: 'Vị trí',
    lastAccessAddress: 'Trang đã truy cập gần đây',
    userID: 'ID khách hàng',
    sex: 'Giới tính',
    boy: 'Nam',
    girl: 'Nữ',
    placeholderSex: 'Xin chọn giới tính',
    tradePlatform: 'Sàn giao dịch',
    accountStatus: 'Tình trạng tài khoản',
    activeTime: 'Thời gian kích hoạt',
    lastMoneyTime: 'Lần gửi tiền cuối cùng',
    tradeHandNum: 'Số lot giao dịch tích lũy',
    lastTradeTime: 'TG giao dịch lần trước',
    accountChannel: 'Kênh mở tài khoản',
    activityNum: 'Số lượng hoạt động tham gia',
    ccFollow: 'Người theo dõi CC',
    placeholderCC: 'Xin nhập vào người theo dõi CC',
    csFollow: 'người theo dõi CS',
    placeholderCS: 'Xin nhập vào người theo dõi CS',
    rmFollow: 'Người theo dõi RM',
    placeholderRM: 'Xin nhập vào người theo dõi RM',
    chatTheme: 'Chủ đề hội thoại',
    placeholderChatTheme: 'Vui lòng chọn một chủ đề trò chuyện',
    chatLevel: 'Cấp độ phiên',
    placeholderChatLevel: 'Vui lòng chọn cấp độ hội thoại',
    placeholderKeywords: 'Xin nhập vào tự key',
    userSource: 'Kênh khách',
    serviceName: 'Tên dịch vụ khách hàng',
    placeholderServiceName: 'Vui lòng chọn tên dịch vụ khách hàng',
    sessionTime: 'Thời lượng trò chuyện',
    userIp: 'IP Truy cập ',
    serviceQuality: 'chất lượng phục vụ',
    placeholderServiceQuality: 'Vui lòng chọn chất lượng dịch vụ',
    chatRecordKey: 'Từ khóa lịch sử trò chuyện',
    placeholderChatRecordKey: 'Vui lòng nhập từ khóa ghi trò chuyện',
  },
  /**
   * 文件上传
   */
  upload: {
    numPrefix: 'Chỉ cho chọn',
    numMid: 'cái file, bây giờ đã chọn',
    numSuffix: 'cái',
    uploadTitle: 'Tải lên file',
    success: 'Tải lên file thành công',
    fail: 'Tải lên file thất bại',
    pleaseUpload: 'Xin tải lên file',
    excelTipOne: 'Chỉ cho tải lên file với hình thức .xlsx',
    excelTipTwo: 'Thể tích file không thể lớn hơn 10M',
    uploadTipPrefix: 'Kéo file vào đây, hoặc',
    uploadTipSuffix: 'Nhấp để tải lên',
    uploadNumTip: 'Chỉ cho tải lên file.xlsx và không hơn 10M',
    downExample: 'Tải xuống bản mẫu',
    uploadButton: 'Tải lên ngay',
    uploadPicTip: 'Chỉ tải lên các tệp jpg / png và không quá 500kb',
    uploadImgTip: 'Chỉ hỗ trợ các tệp jpg/png/gif ',
    uploadPicFail: 'Hình ảnh tải lên thất bại, vui lòng thử lại sau',
    uploadingImg: 'Đang tải lên hình ảnh'
  },
  /**
   * 机器人配置页面
   */
  robotList: {
    name: 'Tên',
    welcome: 'Chào đón Robot',
    remark: 'Miêu tả'
  },
  /**
   * 知识分类页面
   */
  knowledgeCategoryList: {
    name: 'Tên phân loại',
    remark: 'Mô tả phân loại',
    createDateRange: 'TG xây dựng'
  },
  /**
   * 知识库页面
   */
  knowledgeList: {
    name: 'Tên kiến thức',
    title: 'Tiêu đề kiến thức',
    keywords: 'Tự key',
    keywordsPlaceholder: 'Giữa nhiều từ key chia bằng dấu phẩy',
    categoryId: 'Tri thức phân loại',
    recommend: 'Giới thiệu hay không',
    content: 'Đáp án câu hỏi',
    createDateRange: 'Thời gian xây dựng',
    export: 'Phát triển kiến thức',
    exportName: 'Tải ra kho tri thức',
    upload: 'Nhập hàng loạt',
    recommendNo: 'Chưa giới thiệu',
    recommendYes: 'Giới thiệu',
    operatorName: 'Người xây dựng',
    open: 'Mở một',
    deposit: 'Tiền gửi',
    withdraw: 'QuKuan',
    transaction: 'Giao dịch',
    activities: 'Các hoạt động mới',
    category: 'Loại gió',
    weight: 'Nặng',
    searchNum: 'Số lần tìm kiếm',
    usefulNum: 'Thời gian hữu ích',
    uselessNum: 'Thời gian vô dụng'
  },
  /**
   * 场景配置
   */
  sceneList: {
    name: 'Tiêu đề tình hình',
    namePlaceholder: 'Xin nhập vào tiêu đề nhập cảnh',
    welcomeMessage: 'Tin nhắn đến',
    directManual: 'Trực tiếp đến CSKH thủ công không',
    createDateRange: 'TG xây dựng',
    addTitle: 'Thêm cảnh mới',
    formBizCode: 'Thuộc nghiệp vụ',
    formBizCodePlaceholder: 'Xin chọn thuộc nghiệp vụ',
    recommendKnowledge: 'Tri thức đề nghị',
    selectKnowledge: 'Chọn tri thức',
    localePlaceholder: 'Xin chọn ngôn ngữ',
    manualService: 'Nhân viên CSKH',
    directManualService: 'Liên hệ CSKH trực tiếp',
    knowledgeTitle: 'Tiêu đề tri thức',
    knowledgeTitlePlaceholder: 'Xin nhập vào tiêu đề tri thức',
    knowledgeType: 'Loại hình tri thức',
    knowledgeTypePlaceholder: 'Xin chọn loại hình tri thức',
    startDate: 'TG bắt đầu',
    startDatePlaceholder: 'Chọn TG bắt đầu',
    endDate: 'TG kết thúc',
    endDatePlaceholder: 'Chọn TG kết thúc',
    knowledgeId: 'ID tri thức',
    knowledgeName: 'Tên tri thức',
    formKnowledgeTitleValid: 'Xin nhập vào tiêu đề cảnh',
    formKnowledgeBizCodeValid: 'Xin chọn nghiệp vụ thuộc loại',
    formKnowledgeLocaleValid: 'Xin chọn ngôn ngữ'
  },
  /**
   * 个人欢迎语
   */
  privateWelcome: {
    message: 'Nội dung'
  },
  /**
   * 自动回复设置
   */
  privateAutoAnswer: {
    message: 'Nội dung'
  },
  /**
   * 首页
   * */
  imIndex: {
    chatStatus: 'Xin chọn trạng thái nhân viên CSKH',
    chatDisconnect: 'Liên kết trò chuyện đã bị gián đoạn, xin liên kết lại',
    refresh: 'Liên kết lại',
    chatTip: 'Thông báo tin nhắn CSKH',
    chatTipCon: 'Bạn có tin nhắn mới, hãy nhớ đọc ',
    notWebSocket: 'Trình duyệt của bạn không ủng hộ socket',
    onopen: 'Xây dựng liên kết...',
    onclose: 'Mất liên kết...',
    onmessage: 'Liên kết thành công'
  },
  /**
   * 内部协同
   */
  chatAllSystem: {
    inputChatName: 'Vui lòng nhập biệt hiệu nhân viên CSKH',
    cueHim: '@Anh ấy',
    personToPerson: 'Trò chuyện riêng'
  },
  /**
   * 对话级别
   */
  chatLevel: {
    createLevel: 'Thêm cấp độ đối thoại mới',
    updateLevel: 'Sửa cấp độ đối thoại',
    chatLevel: 'Cấp độ phiên',
    level: 'Cấp độ'
  },
  /**
   * 对话主题
   */
  chatTheme: {
    createTheme: 'Them chủ đề mới',
    updateTheme: 'Sửa chủ đề',
    theme: 'Chủ đề'
  },
  /**
   * 桌面对话窗口设置
   */
  desktopChat: {
    clickEditLogo: 'Nhấp để chỉnh sửa LOGO',
    editLogo: 'Biên soạn LOGO',
    clickEditBgColor: 'Nhấp để chỉnh sửa màu nền',
    editBgColor: 'Biên soạn màu sắc bối cảnh ',
    background: 'Màu sắc bối cảnh',
    clickAd1: 'Nhấp vào biên soạn quảng cáo 1',
    clickAd2: 'Nhấp vào biên soạn quảng cáo 2',
    editAd: 'Biên soạn quảng cáo',
    isVerify: 'Có  mã xác minh mở tài khoản không',
    logoHrefUrl: 'Chuyển đổi liên kết',
    inputLogoHrefUrl: 'Xin nhập vào liên kết chuyển đổi',
    adPic: 'Hình ảnh quảng cáo'
  },
  /**
   * 访客IP限制设置
   */
  limitVisitorsIP: {
    addLimit: 'Thêm giới hạn du khách',
    updateLimit: 'Sửa giới hạn du khách',
    limitType: 'Loại hình giới hạn',
    limitTypeCon: 'Nội dung loại hình giới hạn',
    placeholderLimitType:"Xin nhập IP hoặc tài khoản",
    limitReason: 'Lý do chặn',
    ip: 'IP',
    account: 'Tài khoản'
  },
  /**
   * 留言设置
   */
  message: {
    title: 'Khách hàng offline,thu thập tin nhắn khách hàng',
    titleCon: 'Tin nhắn khách hàng offline nghĩa là khi khách hàng vào hệ thống CSKH nhưng không có nhân viên CSKH online, nên khách hàng đã để lại tin nhắn',
    form: 'Mục biểu mẫu',
    isRequired: 'Nó có bắt buộc không',
    adaptationBizCode: 'Kinh doanh thích ứng',
    EffectPreview: 'Xem trước hiệu quả',
    message: 'Tin nhắn',
    editMessageGuide: 'Biên tập tin nhắn hướng dẫn',
    clickEditMessageGuide: 'Biên tập tin nhắn hướng dẫn',
    messageGuide: 'Tin nhắn hướng dẫn',
    messageSuc: 'Nội dung trang thông báo thành công'
  },
  /**
   * 常用文件管理/链接管理/图片管理
   */
  oftenFile: {
    inputTitleKey: 'Xin nhập vào tự key tiêu đề',
    uploadFile: 'Tải lên file',
    updateFile: 'Sửa file',
    addOftenHref: 'Thêm Link thường dùng mới ',
    updateOftenHref: 'Sửa link thường dùng',
    hrefUrl: 'Địa chỉ link',
    titleOrHref: 'Tiêu đề hoặc địa chỉ link không thể bỏ trống',
    pic: 'Hình ảnh',
    uploadPic: 'Tải lên hình ảnh'
  },
  /**
   * 访问分配设置
   */
  visitorsDistribution: {
    prioritySet: 'Cài đặt cấp ưu tiên',
    priorityCon: 'Ưu tiên sẽ được phân phối cho nhân viên CSKH lần trước <em>(Lưu ý: mặc định là 5 ph</em>',
    priorityExplain: 'Nếu khách truy cập không phải trực tuyến lần đầu tiên, thì sẽ được chỉ định cho nhân viên CSKH được chỉ định lần trước trong thời gian quy định, nếu nhân viên CSKH đó không trực tuyến thì sẽ được chỉ định như một khách hàng bình thường;',
    allocationSet: 'Cài đặt phương thức phân phối',
    allocationType1: 'Loại tiêu thủ--Hệ thông sẽ phân phối du khách cho mỗi nhân viên CSKH, nếu số người tiếp đón của CSKH đó đã đầy, thì bỏ qua',
    allocationType0: 'Loại CSKH - hệ thống phân phối cho nhân viên CSKH với khối lượng công việc nhỏ (khối lượng công việc bằng số lượng khách hiện đang nhận chia cho số lần tối đa tiếp khách trực tuyến), nếu khối lượng giống nhau thì sẽ giao cho người  không nhận được khách mới lâu nhất.',
    allocationType2: 'Ưu tiên nhân viên CSKH được phân phối cuộc trò chuyện ít nhất',
    editChatRelated: 'Biên tập nhân viên CSKH liên quan',
    chatId: 'ID nhân viên CSKH',
    id: 'ID',
    userName: 'Tên đăng nhập',
    displayName: 'Tên nick',
    rolesStr: 'Vai trò',
    companyName: 'Thuộc công ty',
    relatedBusiness: 'Nghiệp vụ liên quan',
    upperLimit: 'Giới hạn tiếp đón',
    minute: 'Phút',
    second: 'Giây',
    hour: 'Tiếng'
  },
  /**
   * 欢迎语
   */
  welcome: {
    title: 'Lời chào mừng',
    addWelcome: 'Thêm lời chào mừng',
    updateWelcome: 'Thêm lời chào mừng'
  },
  /**
   * 留言管理
   */
  messageManagement: {
    messageDetailTitle: 'Chi tiết tin nhắn',
    messageCon: 'Nội dung tin nhắn',
    replyCon: 'Nội dung trả lời',
    placeholderReply:"Vui lòng nhập nội dung trả lời",
    replyNo: 'Chưa trả lời',
    replyYes: 'Đã trả lời',
    all: 'Tất cả',
    cityArea: 'Khu thành phố',
    saveMessageSuc: 'Lưu tin nhắn thành công',
    saveMessageFail: 'Lưu tin nhắn thất bại, vui lòng thử lại sau',
    isNull: 'Nội dung trả lời không thể bỏ trống',
    messageExport: 'Xuất thông điệp'
  },
  /**
   * 聊天框
   */
  chatRoom: {
    offline: 'Khách hàng đã offline',
    artificialChat: 'Tiếp đón khách hàng này',
    artificialFail: 'Tiếp đón thất bại, vui lòng thử lại sau！',
    notArtificial: 'Hiện đang không có đối tượng trò chuyện, không thể tiếp đón khách hàng, xin chọn đối tượng trò chuyện đã',
    fileType: 'Cách thức file không đúng',
    picType: 'Hình ảnh không thể lớn hơn 5M',
    sendNotNull: 'Nội dung gửi không thể bỏ trống',
    notSend: 'Hiện đang không có đối tượng trò chuyện, không thể gửi tin nhắn, xin chọn đối tượng trò chuyện đã',
    noMore: 'Không còn dữ liệu nữa'
  },
  /**
   * 对话管理
   */
  commonChat: {
    waitAccept: 'Được kết nối',
    waitEvaluated: 'Để được đánh giá',
    acceptSession: 'Chấp nhận cuộc trò chuyện',
    limitVisitorsIP: 'Cài đặt hạn chế IP của khách',
    chatMonitor: 'Giám sát dịch vụ khách hàng',
    enableAutoReply:"Bắt đầu trả lời tự động",
    closeAutoReply:"Tắt trả lời tự động",
    customerInfo: 'thông tin khách hàng',
    historyChat: 'Cuộc trò chuyện lịch sử',
    sourceHref: 'Nhấp để xem liên kết nguồn',
    chatList: 'Danh sách cuộc trò chuyện',
    chatEnd: 'Kết thúc cuộc trò chuyện',
    chatSend: 'Gửi cuộc trò chuyện',
    waitAcceptInfo: 'Thông tin chờ đón vào',
    accept: 'Đón vào',
    acceptAll: 'Đón vào tất cả',
    send: 'Gửi chuyển',
    waitEvaluatedInfo: 'Thông tin chưa đánh giá',
    goEvaluated1: 'và',
    goEvaluated2: 'tiến hành đánh giá',
    chatRecord1: 'và',
    chatRecord2: 'Lịch sử đối thoại',
    chatStart: 'Bắt đầu đối thoại',
    chatEnds: 'Đối thoại kết thúc',
    customerOff: 'Khách hàng offline',
    chatClose: 'Nhân viên CSKH chủ động đóng đối thoại',
    evaluatedInfo: 'Thông tin đánh giá',
    isNotNull: 'Chủ đề đối thoại và cấp độ đối thoại không thể bỏ trống',
    acceptSessionInfo: 'Tiếp nhận thông tin đối thoại',
    reception: 'Tiếp nhận',
    refusal: 'Từ chối',
    chatSendInfo: 'Gửi chuyển thông tin đối thoại',
    sender: 'Người gửi chuyển',
    receiver: 'Người tiếp nhận',
    chatID: 'Id đối thoại',
    sendReason: 'Lý do gửi chuyển',
    placeholderSendReason: 'Xin nhập vào lý do gửi chuyển',
    chatInfo: 'Chi tiết đối thoại',
    checkChatMonitor: 'Chọn nhân viên CSKH giám sát',
    noData: 'Không có dữ liệu',
    commonWords: 'Lời thường dùng cộng đồng',
    personalWords: 'Lời thường dùng cá nhân',
    commonHref: 'Link thường dùng',
    commonImg: 'Hình ảnh thường dùng',
    commonFile: 'File thường dùng',
    endReason: 'Nguyên nhân kết thúc',
    checkChat: 'Xin chọn khách hàng đối thoại！',
    notEdit: 'Thông tin của khách hàng hiện đang là không thể biên soạn, xin thay đổi trạng thái cho biên soạn đã！',
    updateSuc: 'Sửa thông tin khách hàng thành công!',
    updateFail: 'Sửa thông tin khách hàng thất bại, vui lòng thử lại sau',
    notCopy: 'Trình duyệt này không cho sao chép tự động',
    length: 'Số chữ tìm từ key phải nhiều hơn 2 chữ',
    evaluatedSuc: 'Đánh giá thành công！',
    acceptSuc: 'Tiếp đón thành công!',
    acceptFail: 'Tiếp đón thất bại, vui lòng thử lại sau',
    sendSingle: 'Chỉ có thể gửi chuyển 1 đối thoại',
    hasSend: 'Đối thoại này đã được gửi chuyển, vui lòng thử đối thoại khác',
    checkSend: 'Xin chọn đối thoại cần gửi chuyển đã',
    notSender: 'Chưa chọn người gửi chuyển, xin chọn người gửi chuyển đã！',
    sendSuc: 'Gửi chuyển thành công！',
    sendFail: 'Gửi chuyển thất bại, vui lòng thử lại sau',
    isAccept: 'Tiếp đón đối thoại không?',
    receptionSuc: 'Tiếp đón thành công！',
    receptionFail: 'Tiếp đón thất bại, vui lòng thử lại sau',
    receptionCancel: 'Đã hủy tiếp đón đối thoại',
    isRefusal: 'Từ chối tiếp đón?',
    refusalSuc: 'Từ chối thành công',
    refusalFail: 'Từ chối thất bại, vui lòng thử lại sau',
    refusalCancel: 'Đã huiwy tiếp đón đối thoại',
    chatEndsFail: 'Kết thúc đối thoại thất bại, vui lòng thử lại sau',
    checkChatEnds: 'Xin chọn đối thoại cần kết thúc',
    startMonitor: 'Bắt đầu giám sát',
    monitorFail1: 'Giám sát',
    monitorFail2: 'Bị thất bại, vui lòng thử lại sau'
  },
  /**
   * 对话记录
   */
  chatRecord: {
    visitorsAccount: 'Tài khoản du khách',
    placeholderAccount: 'Vui lòng nhập tài khoản',
    visitorsType: 'Phương thức khách phỏng',
    placeholderVisitorsType: 'Vui lòng chọn phương thức khách truy cập',
    serviceQuality0: 'Chưa bình luận',
    serviceQuality1: '1 sao',
    serviceQuality2: '2 sao',
    serviceQuality3: '3 sao',
    serviceQuality4: '4 sao',
    serviceQuality5: '5 sao',
    saveSuc:"Đánh giá thành công！Đối thoại này là cuộc đối thoại cuối cùng trong trang này. Xin hãy đến danh sách trước và sang trang kế tiếp",
    noNext: 'Đối thoại này là cuộc đối thoại cuối cùng trong trang này. Xin hãy đến danh sách trước và sang trang kế tiếp'
  },
  /**
   * 常用语
   */
  commonWords: {
    addCommonWordsList: 'Thêm danh sách các từ thông dụng mới',
    addCommonWords: 'Thêm từ thông dụng mới',
    importAll: 'Nhập hàng loạt',
    commonWordsList: 'Danh sách các từ thông dụng',
    placeholderCommonWordsList: 'Xin chọn mục lục lời thường dùng',
    contentTxt: 'Nội dung',
    updateCommonWords: 'Sửa lời thường dùng',
    updateCommonWordsList: 'Sửa đổi danh sách các từ phổ biến',
    checkDel: 'Xin chọn mục cần xóa',
    notCommonWordsList: 'Mục lục lời thường dùng không thể bỏ trống, xin nhập vào mục lục lời thường dùng',
    notCommonWordsList1: 'Mục lục lời thường dùng không thể bỏ trống, xin xây dựng mục lục lời thường dùng đã',
    notTitle: 'Tiêu đề không thể bỏ trống, xin nhập vào tiêu đề'
  }
}

